import { render, staticRenderFns } from "./BindGameacc2.vue?vue&type=template&id=8ee6dbb4&scoped=true&"
import script from "./BindGameacc2.vue?vue&type=script&lang=js&"
export * from "./BindGameacc2.vue?vue&type=script&lang=js&"
import style0 from "./BindGameacc2.vue?vue&type=style&index=0&id=8ee6dbb4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ee6dbb4",
  null
  
)

export default component.exports